import React from "react";
import { formatPixelDimensions } from "../../../../utils/getTransform";
import { useImageNaturalSize } from "../../lib/toolPrepImageLayout";
import "./ToolPrepCanvasMeta.css";

/**
 * Pixel resolution under any tool-prep image stage.
 * Prefer explicit width/height when the tool changes output size (resize, crop, …).
 */
const ToolPrepCanvasMeta = ({
  imageUrl = null,
  width = null,
  height = null,
  className = "",
}) => {
  const natural = useImageNaturalSize(
    Number(width) > 0 && Number(height) > 0 ? null : imageUrl
  );
  const w = Number(width) > 0 ? Math.round(Number(width)) : natural.width;
  const h = Number(height) > 0 ? Math.round(Number(height)) : natural.height;
  const resolutionLabel = formatPixelDimensions(w, h);

  if (!resolutionLabel) return null;

  return (
    <div
      className={`tool-prep-canvas-meta${className ? ` ${className}` : ""}`}
      aria-live="polite"
    >
      <span className="tool-prep-canvas-meta__value">{resolutionLabel}</span>
    </div>
  );
};

export default ToolPrepCanvasMeta;
